
import React, {useEffect, useState} from 'react';
import {search_resort_count} from '../../../service/search'
import rombus from '../../../media/rombus.gif'

const ResortTopList = ({client_id, agent_id, prod_type=null, date_from=null, date_to=null, title=null, max_items=10, token, timeout=1000}) => {

    const [listData, set_list_data] = useState(null);

    const  popd = (client_id, agent_id, date_from, date_to, prod_type) => {

        setTimeout(() => {
         search_resort_count(client_id, agent_id, null, null, null, date_from, date_to, null, null, null, prod_type, token).then((d) => {
            if(d != null){
                set_list_data(d)
            }
        });           
        }, timeout);

    }
    

    let cTitle = 'Top Resorts';
    if(title != null){
        cTitle = title;
    }

    useEffect(() =>{
        set_list_data(null);
        popd(client_id, agent_id, date_from, date_to, prod_type);
    }, [client_id, agent_id, date_from, date_to, prod_type])

    if(listData == null){
            return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }

    const lItems = [];
    let c = 0;
    for(const x of listData){
        if(c == max_items){
            break;
        }
        lItems.push(<li>{x.name}</li>);
        c++;
    }

    return (<div className='listBlock'>
        <div className='listBlockTitle'>
            {cTitle}
        </div>
        <div className='listBlockContent'>
            <ul>
                {lItems}
            </ul>

        </div>
    </div>)

}

export default ResortTopList
